import * as React from "react";
import './WarningMessage.scss';

/** @import {WarningMessageProps} from "./WarningMessageTypes" */
export default function WarningMessage(/** @type {WarningMessageProps} */WarningMessageProps) {
    
    const defaultMessage = (
        <div className={"messageText"}>
            Please make sure your linked account is still active, and that we have the right
            details. If
            you need to update it, go to <a href="/account-details">Manage account(s)</a> to
            update your
            details before you give us any instructions.
        </div>
    );

    return (
        <div className={"warningContainer"} role="alert">
            <div className={"messageContent"}>
                <div className={"messageWrapper"}>
                    <div className={"messageIconText"}>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/12701b2bc19776cb3fa73ebae9a48d812d1538247a6e5d03728844e845309bc3?placeholderIfAbsent=true&apiKey=818a1763d6f1455a8e12b5148c04fc79"
                            className={"warningIcon"}
                            alt="Warning icon"
                        />
                        <div className={"messageText"}>
                            {WarningMessageProps?.selectedAccountType === "Linked Account" ? 
                                defaultMessage : <div className={"messageText"}>{WarningMessageProps?.body}</div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}